import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn';
import { springGentle } from '../tokens';
import { Button } from './Button';

type EmptyStateProps = {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  className?: string;
};

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={springGentle}
      className={cn(
        'flex flex-col items-center text-center px-screen-x py-section-gap',
        className,
      )}
    >
      <div className="text-text-tertiary mb-4">{icon}</div>
      <h3 className="text-section text-text-primary mb-label-gap">{title}</h3>
      {description ? (
        <p className="text-body text-text-secondary max-w-[320px]">
          {description}
        </p>
      ) : null}
      {action ? (
        <div className="mt-section-gap">
          <Button variant="primary" size="md" onClick={action.onClick}>
            {action.label}
          </Button>
        </div>
      ) : null}
    </motion.div>
  );
}
